import React, { memo } from 'react'
import { useDrag } from 'react-dnd'
import { speech } from '../utils/utils'

const style = {
  border: '1px dashed gray',
  backgroundColor: 'white',
  padding: '0.5rem 1rem',
  marginRight: '1.5rem',
  marginBottom: '1.5rem',
  cursor: 'move',
  float: 'left',
}
export const Box = memo(function Box({ name, type, isDropped }) {
  function handleBoxClick() {
    speech(name)
  }
  const [{ opacity }, drag] = useDrag(
    () => ({
      type,
      item: { name },
      collect: (monitor) => ({
        opacity: monitor.isDragging() ? 0.4 : 1,
      }),
    }),
    [name, type]
  )
  return (
    <div
      ref={drag}
      role="Box"
      style={{ ...style, opacity }}
      onClick={handleBoxClick}
    >
      {isDropped ? <s>{name}</s> : name}
    </div>
  )
})
